var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"name_class",on:{"click":_vm.init}},[_vm._v(_vm._s(_vm.val))]),_c('vehicle-module',{ref:"vehicleModule",attrs:{"form":_vm.form},on:{"updateName":_vm.updateName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }